import { FunctionComponent } from "react";
import {
  Routes as BrowserRoutes,
  BrowserRouter,
  Route,
} from "react-router-dom";

import { BASE_ROUTES } from "src/Constant/baseRoute";

import PrivateRoute from "src/Routes/PrivateRoute";
import GetUserProfileProvider from "src/Context/UserProfile";
import MonitorOngoingBulkCheckProvider from "src/Context/RadarCheck/MonitorOngoingBulkCheck";
import CancelReactivateSubscriptionProvider from "src/Context/Billing/CancelReactivateSubscription";
import GetBulkRecordsProvider from "src/Context/RadarCheck/GetBulkRecords";
import OngoingBulkTransactionsProvider from "src/Context/TransactionMonitoring/OngoingBulkTransactions";
import NotificationAlertProvider from "src/Context/UserProfile/NotificationAlert";

const Routes: FunctionComponent<Record<string, never>> = () => {
  return (
    <BrowserRouter basename="/">
      <BrowserRoutes>
        {BASE_ROUTES.map(({ useAuth, path, Component, Layout }) => (
          <Route
            path={path}
            key={path}
            element={
              useAuth && Layout ? (
                <PrivateRoute>
                  <GetUserProfileProvider>
                    <MonitorOngoingBulkCheckProvider>
                      <GetBulkRecordsProvider>
                        <OngoingBulkTransactionsProvider>
                          <NotificationAlertProvider>
                            <CancelReactivateSubscriptionProvider>
                              <Layout>
                                <Component />
                              </Layout>
                            </CancelReactivateSubscriptionProvider>
                          </NotificationAlertProvider>
                        </OngoingBulkTransactionsProvider>
                      </GetBulkRecordsProvider>
                    </MonitorOngoingBulkCheckProvider>
                  </GetUserProfileProvider>
                </PrivateRoute>
              ) : (
                <Component />
              )
            }
          />
        ))}
      </BrowserRoutes>
    </BrowserRouter>
  );
};

export default Routes;
